import { render } from "./SensorTypeEdit.vue?vue&type=template&id=24836bfa&ts=true"
import script from "./SensorTypeEdit.vue?vue&type=script&lang=ts"
export * from "./SensorTypeEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__